import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { login as apiLogin } from '../api/client';

export default function Login() {
  const { login } = useAuth();
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr('');
    try {
      const res = await apiLogin(u, p);
      login(res.data.access_token, res.data.username, res.data.role, res.data.workspace, res.data.exports_enabled);
    } catch(e) {
      const msg = e.response?.data?.detail || e.message || '';
      setErr(msg || 'Incorrect username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f4f0'}}>
      <div style={{background:'#fff',border:'1px solid #e2e0d8',borderRadius:16,padding:'48px 40px',width:380,boxShadow:'0 4px 16px rgba(0,0,0,.09)'}}>
        <h1 style={{fontSize:22,fontWeight:600,letterSpacing:'-.5px',marginBottom:4}}>Adiko</h1>
        <p style={{fontSize:11,color:'#9b9890',fontFamily:'DM Mono,monospace',marginBottom:32}}>EXPORT DASHBOARD · v1.0</p>
        <form onSubmit={submit}>
          <div style={{marginBottom:16}}>
            <label style={{display:'block',fontSize:11,fontWeight:500,color:'#6b6960',marginBottom:5,textTransform:'uppercase',letterSpacing:.5}}>Username</label>
            <input value={u} onChange={e=>setU(e.target.value)} placeholder="Username"
              style={{width:'100%',padding:'10px 14px',border:'1px solid #cccac0',borderRadius:6,fontSize:14,outline:'none'}} />
          </div>
          <div style={{marginBottom:16}}>
            <label style={{display:'block',fontSize:11,fontWeight:500,color:'#6b6960',marginBottom:5,textTransform:'uppercase',letterSpacing:.5}}>Password</label>
            <div style={{position:'relative'}}>
              <input type={showPwd ? 'text' : 'password'} value={p} onChange={e=>setP(e.target.value)} placeholder="Password"
                style={{width:'100%',padding:'10px 42px 10px 14px',border:'1px solid #cccac0',borderRadius:6,fontSize:14,outline:'none',boxSizing:'border-box'}} />
              <button type="button" onClick={()=>setShowPwd(s=>!s)}
                style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'#9b9890',padding:0,fontSize:16,lineHeight:1}}>
                {showPwd ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          {err && <p style={{color:'#dc2626',fontSize:12,marginBottom:8}}>{err}</p>}
          <button type="submit" disabled={loading}
            style={{width:'100%',padding:11,background:'#1a1917',color:'#fff',borderRadius:6,fontSize:14,fontWeight:500,opacity:loading?.7:1}}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
